import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent } from 'core/components'
import { Row, Col, BlockTitle as Block, List, ListItem, Radio, Button, Icon } from 'core/components/Framework7';
import { AddressItem } from 'content/components';
import { setAddress } from 'content/pages/OrderStep/Module'

import { StepsTab } from "./Components/StepsTab";

import classes from './styles.module.css';

class AddressList extends PureComponent {
  constructor(props) {
    super(props);

    const view = this.$f7.views.get('#view-cart')
    this.router = view && view.router

    this.state = {
      value: null,
      // isAddress: false,
    }

    this.$f7.dialog.preloader('در حال دریافت اطلاعات');
  }

  componentDidMount() {
    this.initialValue()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log("componentDidUpdate")
    // console.log("prevProps:", prevProps, "prevState:", prevState)
    const { order, user } = this.props
    // const { value } = this.state

    if (order && user) {
      this.$f7.dialog.close()
    }

    // console.log("value:", value, "order:", order, "user:", user)
    if (!this.state.value) {
      this.initialValue();
    }
  }

  initialValue() {
    const { order, user } = this.props

    if (!order) return

    const shippingInfoAddressId = order.shippingInfo ? order.shippingInfo.addressId : null

    for (const userAddress of user.addresses) {
      if (userAddress.addressId == shippingInfoAddressId) {
        // console.log("shippingInfoAddressId:", shippingInfoAddressId)

        this.setState({
          value: shippingInfoAddressId
        })

        return
      }
    }

    if (user.addresses.length > 0) {
      this.setState({
        value: user.addresses[0].addressId
      })
    }
  }

  parseAddress(data) {
    return {
      id: data.addressId,
      addressTitle: data.address ? data.address.title : null,
      address: data.address ? data.address.text : null
    }
  }

  // handleAddAddress() {
  //   this.props.navigate.navigate('/address/new')
  // }

  handleNext() {
    const { order, user } = this.props;
    const { value } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const id = order ? order.id : null;

    const param = {
      store: 2,
    }

    const model = {
      address_id: Number(value),
      description: "",
      // method_id: 1,
      myself: false,
      phone: user.mobile,
      postal_code: null,
      recipient: user.firstName + " " + user.lastName,
      text: "",
    }


    this.props.setAddress(id, model, param)
      .then(r => {
        // console.log('address step:', this.props.navigate)
        // this.props.navigate.navigate('/step/payment_type', { props: { navigate: this.props.navigate } })
        this.router && this.router.navigate('/step/payment_type')
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  changeAddress(event) {
    // console.log("address changed to:", event.target.name, event.target.value)
    this.setState({
      value: Number(event.target.value)
    })
  }

  renderAddresses() {
    const { user } = this.props;
    if (user && user.addresses && user.addresses.length > 0) {
      return (
        <List mediaList>
          {user.addresses.map(address => {
            return this.renderAddressOption(address)
          })}
        </List>
      )
    }

    return this.emptyAddress()
  }

  renderAddressOption(item) {
    const { value } = this.state;

    // console.log('defChecked:', defChecked, 'item.addressId:', item.addressId, "value:", value)

    return (
      <AddressItem
        radio
        key={item.addressId}
        item={item}
        name="address"
        value={item.addressId}
        checked={item.addressId == value}
        onChange={event => this.changeAddress(event)}
      />
    )
  }

  emptyAddress() {
    return (
      <div className={classes.emptyAddress}>
        <h4 >لیست آدرس های شما خالی است</h4>
      </div>
    )
  }

  render() {
    const { value, isAddress } = this.state;
    const { order, orderLoading } = this.props;

    // console.log('navigate:', this.props.navigate)

    return (
      <div className={classes.container}>
        {/* TODO create component */}
        <StepsTab step={1} />

        <Button large raised
          href='/address/new'
          text={'اضافه کردن آدرس'}
          icon="mdi-plus"
          className={`${classes.fullWidthButton} ${classes.addAddressButton}`}
        // onClick={this.handleAddAddress}
        />

        <div className={classes.pagePadding}>
          {this.renderAddresses()}
        </div>

        <Button large fill
          // href='/step/payment_type'
          disabled={!value || !order || orderLoading}
          icon="mdi-arrow-left"
          text={orderLoading ? "درحال تحلیل سفارش" : "مرحله بعد"}
          className={classes.fullWidthButton}
          onClick={() => this.handleNext()}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    order: state.Order.order,
    user: state.General.user
  }),
  {
    setAddress
  }
)(autobind(AddressList))